import C from "@/components/HeroBlock.module.css";

import { ContentPane } from "@/components/ContentPane.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { cn } from "@/utils/classNames.ts";
import { useTitle } from "@/utils/react/useTitle.ts";
import type { ReactNode } from "react";

export function HeroBlock({
    children,
    title,
    icon,
    className,
}: {
    children: ReactNode;
    title: string;
    icon?: string;
    className?: string;
}) {
    useTitle(title);

    return (
        <ContentPane>
            <div className={C.HeroBlock}>
                <h1 className="pb-3">{title}</h1>
                <div className={cn(C.HeroContent, className)}>{children}</div>
                {!!icon && (
                    <div className={C.HeroIcon}>
                        <MaskIcon className={`${icon} size-100%`} />
                    </div>
                )}
            </div>
        </ContentPane>
    );
}
